"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function hasEqualCharacterData(left = { styles: [] }, right = { styles: [] }) {
    return left != null && right != null &&
        Array.from(left.styles || []).sort().join('') === Array.from(right.styles || []).sort().join('');
}
function createTextFragments(value) {
    const start = [];
    return value.reduce((acc, data, index) => {
        if (acc.length < 1) {
            const el = {
                text: value[index].char
            };
            if (data.styles)
                el.styles = data.styles;
            return [el];
        }
        else {
            const lastFragment = acc[acc.length - 1];
            if (hasEqualCharacterData(lastFragment, data)) {
                return acc.slice(0, -1).concat([Object.assign(Object.assign({}, lastFragment), { text: lastFragment.text + value[index].char })]);
            }
            else {
                const el = {
                    text: value[index].char
                };
                if (data.styles)
                    el.styles = data.styles;
                return [
                    ...acc,
                    el
                ];
            }
        }
    }, start);
}
exports.default = createTextFragments;
//# sourceMappingURL=createTextFragments.js.map